import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import Icon from '../../../Icons/Icon';
import ButtonRow from '../../../ButtonRow/ButtonRow';
import * as Styled from './CardOverlay.styled';
import { handleNavigate } from '../../../../util/util';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
var CardOverlay = function (_a) {
    var className = _a.className, ctas = _a.ctas, _b = _a.ctaVerticallyCentered, ctaVerticallyCentered = _b === void 0 ? true : _b, onRequestClose = _a.onRequestClose, _c = _a.responsiveTextSizes, responsiveTextSizes = _c === void 0 ? undefined : _c, _d = _a.withShadow, withShadow = _d === void 0 ? true : _d;
    var router = useRouter();
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(Styled.CardOverlay, { className: className, responsiveSizes: responsiveTextSizes, withShadow: withShadow, "$styleQueryMode": styleQueryMode },
        React.createElement(Styled.CloseButton, { onClick: function () { return onRequestClose(); }, "data-testid": "card-overlay-close-button" },
            React.createElement(Icon, { name: "close", size: "inherit" })),
        ctas && (ctas === null || ctas === void 0 ? void 0 : ctas.length) && (React.createElement(Styled.CTAs, { verticallyCentered: ctaVerticallyCentered, responsiveSizes: responsiveTextSizes, "$styleQueryMode": styleQueryMode }, ctas.map(function (_a, index) {
            var url = _a.url, text = _a.text;
            return (React.createElement(ButtonRow, { index: index, key: text, titleSize: "mini", title: text, colorMode: "day", onPrimaryActionClick: function () {
                    handleNavigate(router, url);
                }, icon: React.createElement(Icon, { name: "arrow-right", variant: "ghost", colorMode: "night", size: "regular" }) }));
        })))));
};
export default CardOverlay;
